import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-mybusiness-reject-dialog',
  templateUrl: './mybusiness-reject-dialog.component.html',
  styleUrls: ['./mybusiness-reject-dialog.component.css']
})
export class MybusinessRejectDialogComponent implements OnInit {
  @ViewChild('reason', {static: false}) reason: ElementRef;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MybusinessRejectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
 
  ngOnInit() {    
  }
  close() {
		this.dialogRef.close();
	}

}
